import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import accessControlDeviceModule from './accessStore/device'

// 社區服務管理： 郵件包裹
import mailPackageModule from './serviceStore/mailPackage'
// 社區服務管理： 社區公告
import communityNoticesModule from './serviceStore/communityNotices'
// 社區服務管理： 繳費通知
import paymentNoticesModule from './serviceStore/paymentNotices'
// 社區服務管理： 瓦斯登記
import gasRegistrationModule from './serviceStore/gasRegistration'
// 社區服務管理： 服務聯繫
import serviceContactModule from './serviceStore/serviceContact'
// 社區服務管理： 公設資訊
import publicfacilityModule from './serviceStore/publicFacility'

import cardManagementModule from './accessStore/cardManagement'
// 車道管理
import numberPlateModule from './accessStore/numberPlate'
// 共用
import commonModule from './commonStore/common'
// 社區管理
import communityModule from './commonStore/community'
// 上傳檔案
import fileModule from './commonStore/file'
import loginModule from './commonStore/login'
import userModule from './commonStore/user'
import serviceProvideModule from './commonStore/serviceProvide'
import householdModule from './householdStore/household'
import systemAccountModule from './systemStore/account'
import systemRoleModule from './systemStore/role'
import systemOperateModule from './systemStore/operate'
import systemFieldModule from './systemStore/field'
import videoModule from './videoStore'
import deviceModule from './deviceStore'
import alarmModule from './alarmStore'
import testModule from './test'

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    mailPackageModule,
    communityNoticesModule,
    paymentNoticesModule,
    gasRegistrationModule,
    serviceContactModule,
    publicfacilityModule,
    accessControlDeviceModule,
    cardManagementModule,
    numberPlateModule,
    commonModule,
    communityModule,
    fileModule,
    householdModule,
    loginModule,
    userModule,
    serviceProvideModule,
    systemAccountModule,
    systemRoleModule,
    systemOperateModule,
    systemFieldModule,
    videoModule,
    deviceModule,
    alarmModule,
    testModule
  }
})
